export const StoreService = {
    getStorage(key: string): string {
        return localStorage.getItem(key) || "";
    },
    setStorage(key: string, value: string): string {
        localStorage.setItem(key, value);
        return value
    }
};
